import styled from 'styled-components'
import { ReactComponent as CommentsIcon } from '@sketch/icons/comments-64'

export const EmptyTextContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 208px;
  text-align: center;

  p:first-of-type {
    padding-bottom: 4px !important; /* stylelint-disable-line declaration-no-important */
  }
`

export const CommentsIconStyled = styled(CommentsIcon)`
  opacity: 0.3;
`
